import React, { useEffect, useState } from "react";
import { Chart, Series, Legend, Export, Tooltip, ArgumentAxis } from 'devextreme-react/chart';
import DateFilter from "../../date-filter/DateFilter";
import DateRange from "../../date-range/DateRange";
import { Button } from 'devextreme-react/button';
import { Popup } from 'devextreme-react/popup'; // Import Popup for modal
import { useSelector } from "react-redux";
import dayjs from 'dayjs';
import STATISTICS_API from "api/statisticsApi";
import { useFetch } from "@hooks/useStatApi";


function BarWidth({ batchNo, type = {}, supplierId: supplierIdProp, batchId = {}, sDate, eDate, filter }) {
    const today = dayjs().startOf('day');
    const oneWeekAgo = today.subtract(1, 'week');
    // Use supplierId from localStorage if available, otherwise from props
    const supplierId =  supplierIdProp || localStorage.getItem('supplierId');
    console.log("sDate", sDate)
  const [dateRange, setDateRange] = useState(eDate ? `${sDate} - ${eDate}` : `${oneWeekAgo.format('YYYY-MM-DD')} - ${today.format('YYYY-MM-DD')}`);
  const [selectedFilter, setSelectedFilter] = useState(filter ? filter : '1W'); // Set '1W' as the default filter
  const batchID = useSelector((state) => state.overview.batchId);
  const shouldFetch = supplierId !== null; // will be null initially, but maybe undefined is also meaningful
const [mFilter, setMfilter] = useState()
const [isModalVisible, setIsModalVisible] = useState(false); // State to control modal visibility

 const [startDate, endDate] = dateRange
    ? dateRange.split(' - ').map(date => dayjs(date, 'YYYY-MM-DD').format('YYYY-MM-DD'))
    : [null, null];
  const params = {

    startDate,
    endDate,
    supplierId,
  };

  const handleRedirect = () => {
    setIsModalVisible(true); // Show the modal instead of opening a new tab
  };

  const closeModal = () => {
    setIsModalVisible(false); // Close the modal
  };

  const { data: colourData, loading: isQualityLoading, refetch } = useFetch(
    "fetchColours",
    STATISTICS_API.colour,
    (!batchNo && shouldFetch) ? params : null

  );

  const { data: colourDataBatch, loading: isQualityBatchLoading } = useFetch(
    "fetchColoursBatch",
    STATISTICS_API.getColorBatch,
    batchNo ? { batchNo, startDate, endDate } : null

  );

  const dataToDisplay = colourDataBatch?.data?.length > 0 ? colourDataBatch?.data : colourData?.data;

  const handleQuickFilter = (filter) => {
    setMfilter(filter)
    console.log("filter3", filter)
    setSelectedFilter(filter); // Update selectedFilter first
    const today = dayjs().startOf('day'); // Ensure it starts from today

    let fromDate = today.format('YYYY-MM-DD'); // Default to today
    switch (filter) {
      case '1W': fromDate = today.subtract(1, 'week').format('YYYY-MM-DD'); break;
      case '1M': fromDate = today.subtract(1, 'month').format('YYYY-MM-DD'); break;
      case '1Q': fromDate = today.subtract(3, 'month').format('YYYY-MM-DD'); break;
      case '1Y': fromDate = today.subtract(1, 'year').format('YYYY-MM-DD'); break;
      case '2Y': fromDate = today.subtract(2, 'year').format('YYYY-MM-DD'); break;
      default: break;
    }

    console.log(`Filter: ${filter}, From: ${fromDate}, To: ${today.format('YYYY-MM-DD')}`);
    setDateRange(`${fromDate} - ${today.format('YYYY-MM-DD')}`);
  };

 

      useEffect(() => {
        if (dateRange) refetch();
      }, [dateRange, refetch]);
      

  return (
    <React.Fragment>
      <div className="lg:flex flex-col lg:flex-row space-y-3 lg:space-y-0 items-center justify-between gap-4 mb-4">
        <div>
          <p className="mb-0 text-xl font-medium">Colour</p>
        </div>
        <div>
          <DateFilter mFilter={mFilter} onFilterChange={handleQuickFilter} selectedFilter={selectedFilter} />
        </div>
        <div className="flex justify-between items-center">
          <DateRange    onDateChange={(newRange) => {
            setDateRange(newRange);
            setSelectedFilter(null); // <--- RESET selectedFilter
          }} dateRange={dateRange} />
          {
            type != "full" ?
          <Button onClick={handleRedirect}  className="ms-2"
            icon="fullscreen"
          />
          : null}

        </div>
      </div>
      
    {
      dataToDisplay?.some(item => item.count > 0 || item.percentage > 0) ? 
        
      
      <Chart
  id="chart"
  dataSource={dataToDisplay}
  rotated={false}
  customizePoint={(pointInfo) => {
  const salmonColors = [
  '#FAE3E3', // 20
  '#F8D1D2', // 21
  '#F5BFC1', // 22
  '#F3ADAF', // 23
  '#F29C9E', // 24
  '#F0878A', // 25
  '#EE7578', // 26
  '#EC6367', // 27
  '#E95155', // 28
  '#E63D43', // 29
  '#E42C32', // 30
  '#D8292F', // 31
  '#CD252C', // 32
  '#C22129', // 33
  '#B61C26'  // 34
];

    
    const index = pointInfo.index % salmonColors.length;
    return { color: salmonColors[index] };
  }}
>
<ArgumentAxis
    discreteAxisDivisionMode="betweenLabels"
    categories={[
      '20', '21', '22', '23', '24', '25', '26', '27', 
      '28', '29', '30', '31', '32', '33', '34'
    ]}
    valueMarginsEnabled={true}
  />

  <Series
    argumentField="filletColor" // this will now go on X-axis
    valueField="count"          // this will go on Y-axis
    name="Fillet Color Count"
    type="bar"
    barWidth={20} // Increased bar width
  >
    {/* <Label
      visible={true}
      font={{ weight: 700, color: "#000" }}
      customizeText={(arg) =>
        `${arg.value} (${arg.point.data.percentage}%)`
      }
    /> */}
  </Series>
  <Legend visible={false} />
  <Export enabled={false} />
  <Tooltip
  enabled={true}
  customizeTooltip={(arg) => {
    const data = arg.point.data;
    return {
      text: `Count: ${data.count}\nPercentage: ${data.percentage}%`,
    };
  }}
/>
<Export
  enabled={true}
  formats={['PNG', 'PDF', 'SVG']}
  fileName="fillet-color-chart"
/>
</Chart>
:
<div className="flex justify-center items-center h-96">
<p className="no-data-text">No Data Found</p>
</div>

}
      {/* Modal for displaying the graph */}
      <Popup
        visible={isModalVisible}
        onHiding={closeModal}
        dragEnabled={true}
        closeOnOutsideClick={true}
        showTitle={true}
        title="Colour"
        width="90%"
        height="90%"
      >
        <div className="flex flex-col space-y-4 custom-graphs">
          {/* Filters inside the modal */}
          <div className="lg:flex flex-col lg:flex-row space-y-3 lg:space-y-0 items-center justify-between gap-4">
            <div>
              <DateFilter
                mFilter={mFilter}
                onFilterChange={handleQuickFilter}
                selectedFilter={selectedFilter}
              />
            </div>
            <div>
              <DateRange
                onDateChange={(newRange) => {
                  setDateRange(newRange);
                  setSelectedFilter(null); // Reset selectedFilter
                }}
                dateRange={dateRange}
              />
            </div>
          </div>

          {/* Chart inside the modal */}
          {dataToDisplay?.some(item => item.count > 0 || item.percentage > 0) ? (
            <Chart
              id="chart"
              dataSource={dataToDisplay}
              rotated={false}
              size={{ height: 600 }} // Increased height
              customizePoint={(pointInfo) => {
              const salmonColors = [
  '#FAE3E3', // 20
  '#F8D1D2', // 21
  '#F5BFC1', // 22
  '#F3ADAF', // 23
  '#F29C9E', // 24
  '#F0878A', // 25
  '#EE7578', // 26
  '#EC6367', // 27
  '#E95155', // 28
  '#E63D43', // 29
  '#E42C32', // 30
  '#D8292F', // 31
  '#CD252C', // 32
  '#C22129', // 33
  '#B61C26'  // 34
];
                
                const index = pointInfo.index % salmonColors.length;
                return { color: salmonColors[index] };
              }}
            >
              <Series
                argumentField="filletColor"
                valueField="count"
                name="Fillet Color Count"
                type="bar"
                barWidth={30} // Increased bar width
              />
              <Legend visible={false} />
              <Export enabled={false} />
              <Tooltip
                enabled={true}
                customizeTooltip={(arg) => {
                  const data = arg.point.data;
                  return {
                    text: `Count: ${data.count}\nPercentage: ${data.percentage}%`,
                  };
                }}
              />
              <Export
                enabled={true}
                formats={['PNG', 'PDF', 'SVG']}
                fileName="fillet-color-chart"
              />
            </Chart>
          ) : (
            <div className="flex justify-center items-center h-96">
              <p className="no-data-text">No Data Found</p>
            </div>
          )}
        </div>
      </Popup>
    </React.Fragment>
  );
}

export default BarWidth;
